export class BaseError extends Error {
  title = 'Error';
  status;
  constructor(
    { title, message, status }: { title: string; message: string; status?: number | string },
    cause?: unknown,
  ) {
    super(message, { cause });
    this.title = title ?? this.title;
    this.status = status ?? 500;
  }

  static is<T extends BaseError>(this: new (...args: any[]) => T, e: unknown): e is T {
    return e instanceof this;
  }
}

export class ValidationError extends BaseError {}

export class ServiceError extends BaseError {}

export class RepositoryError extends BaseError {}

export class FetchError extends BaseError {}
